<!-- 人员检索组件 -->
<template>
  <div style="height: calc(89vh)" class="persion-search-comp">
    <div class="search-title map-blur-panel__title">条件检索</div>
    <div class="searchForm">
      <el-form
        ref="ruleForm"
        :model="formData"
        :rules="rules"
        label-position="right"
        label-width="95px"
      >
        <div style="display: flex">
          <div
            style="
              flex: 1;
              display: flex;
              justify-content: flex-start;
              height: calc(22vh);
              text-align: center;
            "
          >
            <el-form-item
              prop="fileList"
              label-width="10px"
              style="width: 100%"
            >
              <div class="upload-img-content">
                <div class="upload-img-item">
                  <el-upload
                    action=""
                    style="border: 1px solid gray"
                    :disabled="
                      (formData.name || formData.idNumber || formData.phone) !==
                      ''
                    "
                    :show-file-list="false"
                    list-type="picture-card"
                    :on-success="handleAvatarSuccess"
                    :on-change="changeFile"
                    :before-upload="beforeAvatarUpload"
                    ref="upload"
                  >
                    <img
                      v-if="imageUrl"
                      :src="imageUrl"
                      style="width: 100%; height: 100%"
                    />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                  <div class="head-portrait">
                    <span>上传头像</span>
                  </div>
                </div>
              </div>
            </el-form-item>
          </div>
          <div class="search_item">
            <el-form-item label="区域：" label-width="100px" prop="areaName">
              <el-input
                @click.native="showTree"
                :readonly="true"
                v-model="formData.areaName"
                style="width: 90%"
                placeholder="请选择区域"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="身份证号："
              label-width="100px"
              prop="idNumber"
            >
              <el-input
                v-model="formData.idNumber"
                :disabled="imageUrl !== ''"
                style="width: 90%"
                placeholder="请输入身份证号"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="开始时间："
              label-width="100px"
              prop="startTime"
            >
              <el-date-picker
                style="width: 90%"
                v-model="formData.startTime"
                type="datetime"
                placeholder="开始时间"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间：" label-width="100px" prop="endTime">
              <el-date-picker
                style="width: 90%"
                v-model="formData.endTime"
                type="datetime"
                placeholder="结束时间"
              >
              </el-date-picker>
            </el-form-item>
          </div>
        </div>
        <el-row>
           <el-col :span="24">
          <el-form-item label="阈  值：" prop="threshold" label-width="75px">
            <el-slider
              style="width: 80%"
              v-model="formData.threshold"
            ></el-slider>
          </el-form-item>
           </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="姓名：" prop="name" label-width="70px">
              <el-input
                v-model="formData.name"
                :disabled="imageUrl !== ''"
                style="width: 90%"
                placeholder="请输入人员姓名"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号：" prop="phone">
              <el-input
                v-model="formData.phone"
                :disabled="imageUrl !== ''"
                style="width: 90%"
                placeholder="请输入手机号"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center">
          <el-button size="mini" type="primary" @click="submitClick('ruleForm')"
            >查询</el-button
          >
          <el-button size="mini" type="info" @click="resetFrom">重置</el-button>
        </el-row>
      </el-form>
    </div>
    <div style="height: calc(39vh)" id="mainList">
      <div style="margin: 0 0 8px 15px">查询结果</div>
      <div
        v-if="searchDataList.length > 0"
        style="height: calc(40vh); overflow: auto"
      >
        <div
          v-for="(item, index) in searchDataList"
          class="searchList"
          :key="index"
        >
          <div style="flex: 1">
            <img
              :src="imgPath(item)"
              class="image"
              onerror="this.src='/images/theme/newDark/default.png'"
              style="width: 90px; height: 90px"
            />
          </div>
          <div style="flex: 3; position: relative">
            <div style="margin: 5px; color: #fff; padding-left: 5px">
              <span style="color: #95a6c1">姓名：</span>
              <span>{{ item.name ? item.name : "陌生人" }}</span>
            </div>
            <div style="margin: 5px; color: #fff; padding-left: 5px">
              <span style="color: #95a6c1">手机号：</span>
              <span>{{ item.phone }}</span>
            </div>
            <div style="margin: 5px; color: #fff; padding-left: 5px">
              <span style="color: #95a6c1">名单组：</span>
              <span class="faceSetName">{{ item.faceSetName }}</span>
            </div>
            <div style="text-align: right">
              <el-button
                type="primary"
                size="small"
                @click="searchTrackDetails(item)"
                >查询人员轨迹</el-button
              >
            </div>
          </div>
        </div>
      </div>
      <div v-else style="text-align: center; margin: 30px">
        <div>
          <img src="@/common/assets/images/empty.svg" class="no-data_img" />
        </div>
        暂无数据
      </div>
    </div>
  </div>
</template>
<script>
import { api } from "../api";
import { Dates, Cache, Bus } from "$utils";
export default {
  props: {
    obj: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {},
  watch: {
    imgFileList: {
      handler(newValue, oldValue) {
        this.formData.fileList = newValue;
      },
      deep: true,
    },
    fileList: {
      handler(newValue, oldValue) {
        this.formData.fileList = newValue;
      },
      deep: true,
    },
  },
  data() {
    return {
      formData: {
        fileList: this.$route.params.fileCode
          ? [this.imgPath(this.$route.params)]
          : [],
        startTime: Dates.format(new Date().getTime() - 24 * 60 * 60 * 1000 * 7),
        endTime: Dates.parse(Dates.format(new Date())),
        area: [],
        areaName: "",
        threshold: Number(Cache.get("SYS_YUZHI")),
        name: "",
        idNumber: "",
        phone: "",
      },
      rules: {
        areaName: [{ required: true, message: "请选择区域" }],
        endTime: [{ required: true, message: "选择结束时间" }],
        startTime: [{ required: true, message: "选择开始时间" }],
        threshold: [{ required: true, message: "请选择阈值" }],
      },
      imageUrl: this.$route.params.fileCode ? this.$route.params.imgSrc : "",
      fileList: [], // 上传图片数组
      imgFileList: [], // 保存名单中上传图片数组
      searchDataList: [],
      personDataList: [],
    };
  },

  methods: {
    imgPath(item) {
      return item ? Bus.imgPath(item.fileCode) : "";
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    // 添加图片
    changeFile(file, fileList) {
      let imgSuffix = file.name.split(".")[file.name.split(".").length - 1];
      if (
        imgSuffix == "jpg" ||
        imgSuffix == "jpeg" ||
        imgSuffix == "bmp" ||
        imgSuffix == "png"
      ) {
        this.imageUrl = URL.createObjectURL(file.raw);
        this.fileId = "";
        this.imgFileList = [file];
      } else {
        this.$message.warning("请上传JPG/ JPEG/BMP/PNG格式文件");
      }
    },
    beforeAvatarUpload(file) {
      return file;
    },
    showTree() {
      this.$emit("searchArea");
    },
    submitClick(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return false;
        }
        let days =
          (Date.parse(this.formData.endTime) -
            Date.parse(this.formData.startTime)) /
          86400000;
        if (days > 7) {
          this.$message.warning("时间周期不能大于1周!");
          return false;
        } else if (days <= 0) {
          this.$message.warning("结束时间必须大于开始时间!");
          return false;
        }
        if (
          !this.formData.name &&
          !this.formData.idNumber &&
          !this.formData.phone &&
          !this.imageUrl
        ) {
          this.$message.warning(
            "人脸图片、人员姓名、身份证号、手机号至少有一个不为空!"
          );
          return false;
        }
        if (!this.fileId && this.imageUrl) {
          this.getFileId();
        } else {
          this.searchPerson();
        }
      });
    },
    getFileId() {
      let formData = new FormData();
      this.imgFileList.map((item) => {
        formData.append("files", item.raw);
      });
      this.$fetch(api.batchFileload, formData).then((res) => {
        res.returnObj.map((item) => {
          this.fileId = item.fileId;
          this.searchPerson();
        });
      });
    },
    searchPerson() {
      let params = {
        pageNo: 1,
        pageSize: 100,
        image: this.fileId,
        areas: this.formData.area,
        startTime: this.getDate(this.formData.startTime),
        endTime: this.getDate(this.formData.endTime),
        threshold: this.formData.threshold,
        faceName: this.formData.name,
        credentialNumber: this.formData.idNumber,
        phone: this.formData.phone,
      };
      const loading = this.$loading({
        target: document.querySelector("#mainList"),
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$fetch(api.peopleSearch, params).then((res) => {
        setTimeout(() => {
          loading.close();
        }, 1000);
        if (res.success) {
          this.searchDataList = res.returnObj ? res.returnObj.list : [];
        } else {
          this.$message.error(res.msgContent);
          // this.resetFrom();
        }
      });
    },
    resetFrom() {
      this.formData.areaName = "";
      this.formData.area = [];
      this.formData.threshold = Number(Cache.get("SYS_YUZHI"));
      this.formData.startTime = Dates.parse(
        Dates.format(new Date().getTime() - 24 * 60 * 60 * 1000 * 7)
      );
      this.formData.endTime = Dates.parse(Dates.format(new Date()));
      this.formData.name = "";
      this.formData.idNumber = "";
      this.formData.phone = "";
      this.imageUrl = "";
      this.searchDataList = [];
      this.$refs["ruleForm"].resetFields();
      this.clearTree();
      this.$map.MapInstance2D.clear();
    },
    clearTree() {
      // this.$parent.$refs["areaTree"].resetTreeData();
    },
    searchTrackDetails(item) {
      console.log(item, "-----------------------renyuan");
      this.nowPersonInfo = item;
      let params = {
        pageNo: 1,
        personnelCode: item.peopleId,
        pageSize: 100,
        fileId: this.fileId || item.fileCode,
        areas: this.formData.area,
        startTime: this.getDate(this.formData.startTime),
        endTime: this.getDate(this.formData.endTime),
        threshold: this.formData.threshold,
        faceSetId: item.faceSetId,
      };
      const loading = this.$loading({
        target: document.querySelector("#pageInfo"),
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.moreList = [];
      this.personDataList = [];
      this.$parent.main = false;
      this.$fetch(api.peopleTrackDetails, params).then((res) => {
        setTimeout(() => {
          loading.close();
        }, 1000);
        if (res.success) {
          if (!res.returnObj || !res.returnObj.length) {
            this.$message("暂无轨迹信息");
            return;
          }
          let cameraLayerId = "CARDEVICE";
          this.$map.MapInstance2D.clearLayer(cameraLayerId);
          res.returnObj.map((val, index) => {
            this.moreList.push({
              length: val.points[0].length,
              flg: 4,
            });
            val.isPeopleShow = false;
            this.$set(this.personDataList, index, val);
          });
          this.$emit("personData", {
            personDataList: this.personDataList,
            moreList: this.moreList,
            nowPersonInfo: item,
          });
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    getDate(time) {
      let year = new Date(time).getFullYear();
      let month = new Date(time).getMonth() + 1;
      let day = new Date(time).getDate();
      let hour = new Date(time).getHours();
      let minutes = new Date(time).getMinutes();
      let second = new Date(time).getSeconds();
      if (day < 10) {
        day = "0" + day;
      }
      if (month < 10) {
        month = "0" + month;
      }
      if (hour < 10) {
        hour = "0" + hour;
      }
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      if (second < 10) {
        second = "0" + second;
      }
      return (
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hour +
        ":" +
        minutes +
        ":" +
        second
      );
    },
  },
};
</script>

<style lang="scss">
@import "~@src/common/assets/style/mixin";
.persion-search-comp {
  .el-upload--picture-card {
    border: none;
  }
  .searchForm {
    margin-bottom: 20px;
    margin: 15px;
    padding: 10px;
    @include set_theme_color(background-color, dialog-main-bg-color);
    .el-form {
      padding: 10px 0;

      .el-upload {
        @include set_theme_color(background-color, dialog-main-bg-color);
      }
    }
  }
  .search-title {
    height: 40px;
    line-height: 40px;
    padding-left: 10px;
    @include set_theme_color(color, font-default-color);
  }
  .search_item {
    flex: 2;
    overflow: hidden;
    height: calc(22vh);
    .el-form-item {
      margin-bottom: 8px;
    }
  }
}
</style>
